module.exports = __webpack_public_path__ + "static/media/corn.52582641.jpg";